export const blockIconsHouseholdMopNew = (
	<span className='material-symbols-outlined'>mop</span>
);
